module.exports = __webpack_public_path__ + "img/e-commerce.b71ee6aa.svg";